import { render, staticRenderFns } from "./RecruiterQaJiraCard.vue?vue&type=template&id=3cadbae7&scoped=true"
import script from "./RecruiterQaJiraCard.vue?vue&type=script&lang=js"
export * from "./RecruiterQaJiraCard.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaJiraCard.vue?vue&type=style&index=0&id=3cadbae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cadbae7",
  null
  
)

export default component.exports